import { getAdminHubSpotConfig } from "../api/api-hook";

// HubSpot IDs that differ between the sandbox and production. They start as the sandbox values and
// are replaced by the backend's (GET /api/admin/hubspot-config), which AdminLayout loads before
// showing any admin page.
export const HUBSPOT_IDS = {
  portalId: "51412984",
  refundedStage: "1351378977",
  partialRefundStage: "1365066640",
  redemptionReversedStage: "1353452392",
};

let loading: Promise<void> | null = null;

export function loadHubSpotIds(): Promise<void> {
  if (!loading) {
    loading = getAdminHubSpotConfig()
      .then((r) => {
        if (r.portalId) HUBSPOT_IDS.portalId = String(r.portalId);
        if (r.refundedStage) HUBSPOT_IDS.refundedStage = r.refundedStage;
        if (r.partialRefundStage) HUBSPOT_IDS.partialRefundStage = r.partialRefundStage;
        if (r.redemptionReversedStage) HUBSPOT_IDS.redemptionReversedStage = r.redemptionReversedStage;
      })
      .catch(() => {
        loading = null; // try again next time an admin page loads
      });
  }
  return loading;
}

export const hubspotRecordUrl = (type: "contact" | "deal", id: string | number) =>
  `https://app.hubspot.com/contacts/${HUBSPOT_IDS.portalId}/${type}/${id}`;
